import './index.html';
import './index.scss';
import './scripts/script';

// og image
import './images/cirus-og.png';
